<template lang="html">
  <div>
    <b-form @submit="login">
      <b-form-group
        id="exampleInputGroup1"
        label="Email address:"
        label-for="exampleInput1"
        description="We'll never share your email with anyone else."
      >
        <b-form-input
          id="exampleInput1"
          v-model="email"
          type="email"
          required
          placeholder="Enter email"
        />
      </b-form-group>

      <b-form-group
        id="exampleInputGroup2"
        label="Password:"
        label-for="password_input"
      >
        <b-form-input
          id="password_input1"
          v-model="password"
          type="password"
          required
          placeholder="Enter password"
        />
      </b-form-group>
      <b-button type="submit" variant="primary">Login</b-button>
    </b-form>
    <p class="mt-3 small">
      Problems logging in? You can reset your password via the
      <a href="https://app.soundslides.com/password_reset">Soundslides app</a>.
    </p>
  </div>
</template>

<script>
export default {
  name: "Login",
  data() {
    return {
      email: "",
      password: "",
      password2: ""
    };
  },
  methods: {
    login(evt) {
      evt.preventDefault();
      console.log("login");
      this.$store.dispatch("login", {
        email: this.email,
        password: this.password
      });
    }
  }
};
</script>

<style lang="css" scoped></style>
